import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FrCardModule } from '../fr-card/fr-card.module';
import { DocumentComponent } from './components/document/document.component';
import { FbShareModule } from '../fb-share/fb-share.module';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';
import { DonateNowModule } from '../donate-now/donate-now.module';
import { SharedModule } from '../../shared/shared.module';
import { SigninSignupComponent } from 'src/app/core/signin-signup/signin-signup.component';
import { BasicButtonComponent } from 'src/app/core/basic-button/basic-button.component';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';

@NgModule({
  imports: [
    CommonModule,
    FrCardModule,
    FbShareModule,
    WhatsappShareModule,
    DonateNowModule,
    SharedModule,
    SigninSignupComponent,
    BasicButtonComponent,
    ComponentLoader
  ],
  declarations: [DocumentComponent],
  exports: [DocumentComponent],
})
export class DocumentModule { }
